import { Zap, Gauge, Wallet, Headphones } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CARDS = [
  {
    icon: Zap,
    title: "Spin up a team fast",
    body: "We suggest the best experts and plug them into your current team.",
  },
  {
    icon: Gauge,
    title: "Reliable turnarounds",
    body: "Content, replies, and reporting delivered on schedule — consistent and on-brand.",
  },
  {
    icon: Wallet,
    title: "Transparent, flat pricing",
    body: "One monthly fee that matches your current demand. Scale up or down anytime.",
  },
  {
    icon: Headphones,
    title: "Human support, always on",
    body: "Never stuck on a request. A real person answers — guaranteed within the hour.",
  },
];

const TOOL_PILLS = ["GPT-5", "Claude", "Gemini", "Veo"];

export const HumanPlusAI = () => (
  <section className="bg-[var(--charcoal)] py-24 text-white md:py-32" data-testid="home-human-ai">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      {/* Heading */}
      <div className="mx-auto max-w-3xl text-center">
        <Reveal>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--mint)]">
            Real experts, supercharged by AI
          </span>
        </Reveal>
        <Reveal delay={100}>
          <h2
            className="mt-6 font-semibold uppercase leading-[0.95] tracking-[-0.02em] text-white"
            style={{ fontSize: "clamp(34px, 5.5vw, 68px)" }}
          >
            Real experts. Real results.
          </h2>
        </Reveal>
      </div>

      {/* Bento grid */}
      <div className="mt-16 grid gap-4 lg:grid-cols-3 lg:auto-rows-fr">
        {/* Large feature card */}
        <Reveal className="lg:row-span-2">
          <div className="flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]">
            <div className="relative flex-1 overflow-hidden">
              {/* mint blob */}
              <div className="absolute left-1/2 top-1/2 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[var(--mint)]/25 blur-2xl" />
              <img
                src={`${process.env.PUBLIC_URL}/team/daniyal-syed.jpg`}
                alt="A named expert who owns the work"
                className="relative z-10 mx-auto mt-8 h-64 w-64 rounded-2xl object-cover"
              />
              <div className="relative z-10 mb-6 mt-5 flex flex-wrap justify-center gap-2 px-6">
                {TOOL_PILLS.map((t) => (
                  <span key={t} className="rounded-full border border-white/15 bg-black/30 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-white/70">
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <div className="p-8 pt-2">
              <h3 className="text-xl font-semibold tracking-tight">A human owns every result</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-white/60">
                Every agent is run by a named expert who reviews the work and answers
                for the number — no black box, no hand-waving.
              </p>
            </div>
          </div>
        </Reveal>

        {/* Four supporting cards */}
        {CARDS.map((c, i) => (
          <Reveal key={c.title} delay={i * 90}>
            <div className="flex h-full flex-col rounded-3xl border border-white/10 bg-white/[0.03] p-8 transition-colors duration-300 hover:border-white/25">
              <span className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[var(--mint)]">
                <c.icon size={20} />
              </span>
              <h3 className="mt-6 text-xl font-semibold tracking-tight">{c.title}</h3>
              <p className="mt-3 text-[15px] leading-relaxed text-white/60">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
